(function () {
  // Before the shopper has actually clicked a size, the Add to Bag
  // button stays visually muted (dimmed, not-allowed cursor) and
  // won't submit — clicking it in that state just does nothing
  // rather than silently adding whichever size happened to be
  // pre-checked by default. The label itself always reads "Add to
  // Bag"; only the disabled state changes once a size is picked.
  //
  // Shopify itself pre-checks the first available size's radio input
  // (product.selected_or_first_available_variant) — that's a real,
  // valid HTML :checked state, so without this the pill would still
  // render as visually "selected" (highlighted) even though the
  // button next to it reads as disabled, which looks like a bug. The
  // .no-size-selected-yet class (removed the moment a real click
  // happens) gates the pill's checked-state CSS so nothing appears
  // selected until the shopper actually taps one.
  function initProduct(productInfo) {
    var variantSelects = productInfo.querySelector('[id^="variant-selects-"]');
    if (!variantSelects) return;

    // Only the real, visible size option — the hidden single-value
    // "Color" radio (always pre-checked, never shown to the shopper)
    // doesn't count as a manual choice.
    var sizeInputs = variantSelects.querySelectorAll(
      '.product-form__input--pill:not(.visually-hidden) input[type="radio"]'
    );
    if (!sizeInputs.length) return;

    var submitButtons = productInfo.querySelectorAll('.product-form__submit');
    if (!submitButtons.length) return;

    variantSelects.classList.add('no-size-selected-yet');

    var hasManualSelection = false;

    function updateButtons() {
      submitButtons.forEach(function (button) {
        if (hasManualSelection) {
          button.removeAttribute('aria-disabled');
        } else {
          button.setAttribute('aria-disabled', 'true');
        }
      });
    }

    sizeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        hasManualSelection = true;
        variantSelects.classList.remove('no-size-selected-yet');
        updateButtons();
      });
    });

    submitButtons.forEach(function (button) {
      button.addEventListener(
        'click',
        function (event) {
          if (!hasManualSelection) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        true
      );
    });

    updateButtons();
  }

  function init() {
    document.querySelectorAll('product-info').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
